export function filterQuotes<
    T extends { isLocalPickup?: boolean | null; showQuoteAsPending?: boolean | null }
>(deliveryOptions: ReadonlyArray<T>): T[] {
    return deliveryOptions?.filter(q => !q.isLocalPickup && !q?.showQuoteAsPending);
}
